export default __webpack_public_path__ + "ef64c6384c2da5ca77b7267ead0ad45e.png";